<template>
  <div class="banner">
    <div class="banner-content w1200">
      <div class="banner-img">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index" @click.native="enterBannerDetails(item)">
            <img :src="item.conver" alt="">
            <h3 >{{ item.title }}</h3>
          </el-carousel-item>
        </el-carousel>

      </div>
      <div class="news">
        <h2 class="nwe-title"><span>新闻</span><span class="more" @click="enterNewsList()">更多>></span></h2>
        <ul class="nwes-list">
          <li class="news-item" v-for="(item,index) in list" :key="index" @click='enterDetaisl(item)'>
            <!-- <h3>{{item.title}}</h3>
            <p v-html="item.subTitle"></p> -->
             <!-- <el-card shadow="hover"> -->
              <div class="cover">
                <img :src="item.conver" alt="">
              </div>
              <div class="hot-content">
                <p class="title">{{item.title}}</p>
                <p class="subtitle">{{item.subTitle}}</p>
                <p class="time">{{formatDate(item.issueTime,true)}}</p>
              </div>
             <!-- </el-card> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { websitePageNews, websiteBannerList } from '@/api/association'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'banner',
  data () {
    return {
      pageNum: 1,
      loading: true,
      list: [],
      bannerList: []
    }
  },
  methods: {
    formatDate,
    addNewMatchList () {
      let that = this
      if (that.loading === true) {
        console.log(that.loading)
        websitePageNews({ pageNo: that.pageNum, pageSize: 3, assoId: localStorage.getItem('assoId'), type: 1 }).then(res => {
          if (res.data.status === 0) {
            that.list = res.data.data.list
            console.log(res.data.data.list)
            that.pageNum += 1
            that.loading = true
          }
        })
      }
    },
    // banner list
    getWebsiteBannerList () {
      let that = this
      websiteBannerList({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          that.bannerList = res.data.data
        }
      })
    },
    enterBannerDetails (item) {
      console.log(item)
    },
    enterDetaisl (item) {
      this.$router.push({
        name: `NewsDetails`,
        params: { newsId: item.id, type: 1 }
      })
    },
    enterNewsList () {
      this.$router.push({
        name: `NewList`,
        params: { type: 1 }
      })
    }
  },
  mounted () {

  },
  created () {
    let that = this
    let timer = setInterval(function () {
      let assoId = localStorage.getItem('assoId')
      if (assoId !== undefined && assoId !== null) {
        that.getWebsiteBannerList()
        that.addNewMatchList()
        clearInterval(timer)
      }
    }, 200)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner{
    width: 100%;
    /* background-color: #0a4181; */
  }
  .banner-content{
    padding: 30px 0px ;
    display: flex;
  }
  .banner-img{
     width: 778px;
  }
  .banner-img img{
    width: 778px;
    display: block;
  }
  .el-carousel__item h3 {
    color: #fff;
    font-size: 14px;
    position: absolute;
    bottom: 0px;
    line-height: 30px;
    background: #000;
    opacity: 0.8;
    width: 100%;
    text-align: center;
  }

  .news{
    margin-left: 30px;
    width: calc( 100% - 798px);
  }
  .nwe-title{
    font-size: 18px;
    color: #409EFF;
    font-weight: bold;
    padding: 5px 0px 5px 12px;
    background: url(../../../../static/images/nwe-shuxian.png) 5px center no-repeat;
    background-size: 3px 17px;
    /* border-bottom: 2px solid #b8b8b8; */
    display: flex;
    justify-content: space-between;
  }
  .nwe-title .more{
    cursor: pointer;
    float: right;
    color: #409EFF;
    font-size: 14px;
    cursor: pointer;
  }
  .nwes-list{
    padding-top:10px;
  }
  .news-item{
    padding:10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 5px;
    /* border-bottom: 1px solid #b8b8b8; */
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }
  .news-item:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-bottom:0px;
    transform: scale(1.02);
    cursor: pointer;
  }
  .news-item .el-card{
    width: 100%;
    overflow: hidden;
  }
  .news-item .el-card .el-card__body{
    overflow: hidden;
    padding: 10px 0px;
  }
  .news-item h3{
    font-size: 18px;
    color:#000;
    line-height:28px;
  }
  .news-item .cover{
    width: 107px;
    height: 60px;
    margin-right: 10px;
    float: left;
  }
  .news-item .cover img{
    display: block;
    width: 107px;
    height: 60px;
  }
  .news-item .hot-content{
    width:calc(100% - 117px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .news-item p {
    font-size:16px;
    color:#000;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
   .news-item p:nth-child(2){
    font-size: 14px;
    color:#666;
  }
  .news-item p:last-child{
    font-size: 12px;
    color:#999;
  }
  .news-item:last-child {
    /* border-bottom: 0px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Banner/Banner.vue